import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/IT-together.jpg';

function PublicSectorITSupport() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Public Sector IT Support and Solutions" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Public Sector IT Support and Solutions</h4>
              <p>
                This sub-department focuses on providing comprehensive IT support to government departments, enabling efficient and effective public service delivery.<br />
                Services include system maintenance, application development, and technical support for various governmental initiatives.<br /><br />
                Our mission is to leverage technology to enhance operational efficiency and ensure seamless service for the public.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Comprehensive IT System Maintenance</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Custom Application Development</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Technical Support and Troubleshooting</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to empowering government operations through reliable IT solutions, ensuring that public services remain accessible and efficient.
              </p>
            </div>
            <div>
              <Link to="/department/technology">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default PublicSectorITSupport;
